import React from "react";
import TableGeneric from "../../../../shared/components/generic/table/table-generic";
import "./simulation-summary.css";

const getGroupClassName = variant => {
	return [
		"simulation-summary__group",
		variant ? `simulation-summary__group--${variant}` : ""
	].filter(Boolean).join(" ");
};

const SimulationSummary = ({
	groups = []
}) => {
	return (
		<div className="simulation-summary">
			{groups.map(group => {
				const hasItems = Array.isArray(group.items) && group.items.length > 0;
				const hasTableData = Array.isArray(group.data) && group.data.length > 0;

				if (!hasItems && !hasTableData) {
					return null;
				}

				return (
					<section
						key={group.key || group.title || group.variant}
						className="simulation-summary__section"
					>
						{group.title && (
							<div className="simulation-summary__title form-generic__subsection-title">
								{group.icon && <group.icon />}
								<span>{group.title}</span>
							</div>
						)}

						{group.type === "table" ? (
							<div className="simulation-summary__table">
								<TableGeneric
									columns={group.columns}
									data={group.data}
									rowKey={group.rowKey}
								/>
							</div>
						) : (
							<div className={getGroupClassName(group.variant)}>
								{group.items.map((item, index) => (
									<div
										key={`${item.label}-${index}`}
										className="simulation-summary__item"
									>
										<span>{item.label}</span>
										<strong>{item.value}</strong>
									</div>
								))}
							</div>
						)}
					</section>
				);
			})}
		</div>
	);
};

export default SimulationSummary;